export default function feedback(state = {}, action = {}) {
  switch (action.type) {
    default:
      return state;
  }
}

// SELECTORS
